import {
  ApiService,
} from '@/internal';

export default class CalendarService extends ApiService {
  index(params = {}) {
    return this.request({
      method: 'get',
      url: 'calendar',
      params,
    });
  }
}
